<template>
  <div class="conten-desc">
    <div class="df vertical desc-space">
      <div class="step-label">{{ props.title }}</div>
    </div>

    <template
      v-for="(submission, submissionIndex) in submissionList"
      :key="submissionIndex"
    >
      <template v-for="(item, index) in submission.list" :key="index">
        <div class="df vertical" :class="isMobile ? '' : 'describe'">
          <div>
            <div class="df desc-space vertical">
              <div class="subtitle">问题类型</div>
              <a-select v-model:value="item.type" :disabled="props.disabled">
                <a-select-option value="外观">外观</a-select-option>
                <a-select-option value="功能">功能</a-select-option>
                <a-select-option value="参数">参数</a-select-option>
              </a-select>
            </div>
            <div class="df desc-space vertical">
              <div class="subtitle">问题描述</div>
              <a-textarea
                v-model:value="item.desc"
                :style="{
                  width: isMobile ? '5rem' : '500px',
                }"
                :disabled="props.disabled"
                auto-size
              ></a-textarea>
            </div>

            <div class="df desc-space vertical">
              <div class="subtitle">图片</div>
              <upload-img-vue
                :attachment="item.picture"
                :disabled="props.disabled"
                :requestFn="uploadInspectionAttachment"
              ></upload-img-vue>
            </div>

            <div class="df vertical">
              <div class="subtitle">视频</div>
              <upload-video-vue
                :attachment="item.video"
                :disabled="props.disabled"
                :requestFn="uploadInspectionAttachment"
              ></upload-video-vue>
            </div>

            <div class="df vertical">
              <div class="subtitle">原因</div>
              <a-textarea v-model:value="item.reason" auto-size></a-textarea>
            </div>
            <div class="df vertical">
              <div class="subtitle">解决方案</div>
              <a-textarea v-model:value="item.solution" auto-size></a-textarea>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { computed, defineComponent, nextTick, reactive, ref, watch } from "vue";
import {
  PlusOutlined,
  MinusCircleOutlined,
  MinusOutlined,
} from "@ant-design/icons-vue";
import {
  Toast,
  uploadMedia,
  showUploading,
  hideUploading,
} from "@/utils/index";
import { uploadInspectionAttachment } from "@/request/view/qualityInspection";
import { saveOrUpdateContentDesc } from "@/request/view/repair";
import uploadImgVue from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "@/views/repairprogress/compoments/uploadVideo.vue";
import { useStore } from "vuex";

export default defineComponent({
  components: {
    PlusOutlined,
    uploadImgVue,
    uploadVideoVue,
    MinusOutlined,
    MinusCircleOutlined,
  },
  props: {
    questionDesc: String,
    disabled: Boolean,
    questionDisabled: Boolean,
  },
  setup(props, context) {
    const store = useStore();

    const isMobile = computed(() => store.state.isMonile);

    const submissionList = reactive([]);

    const question = reactive([]);

    const uploadFile = () => {
      return JSON.stringify(submissionList);
    };

    watch(
      () => props.questionDesc,
      (val) => {
        submissionList.length = 0;
        if (val) {
          submissionList.push(...JSON.parse(val));
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      store,
      uploadFile,
      question,
      isMobile,
      submissionList,
      uploadInspectionAttachment,
    };
  },
});
</script>

<style lang="less" scoped>
.conten-desc {
  margin-bottom: 20px;
  .subtitle {
    font-size: 16px;
    width: 90px;
    text-align: right;
    margin: 10px 16px 10px 0;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  .describe {
    background: #f9f9f9;
    border-radius: 6px;
    padding: 24px;
  }
  .desc-space {
    margin-bottom: 16px;
  }
  .dynamic-delete-button {
    margin-left: 20px;
    cursor: pointer;
    position: relative;
    top: 4px;
    font-size: 24px;
    color: #999;
    transition: all 0.3s;
  }
  .dynamic-delete-button:hover {
    color: #777;
  }
  .dynamic-delete-button[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.button-space {
  margin-top: 20px;
}
</style>
